import { Trans } from '@lingui/react/macro';
import { Stack } from '@mui/system';
import { Banner } from 'components/banner/banner';
import { ClockFilledIcon } from 'components/icons/ClockFilledIcon';
import type { PharmacyPanelist } from 'types/api/pharmacies/panelist_connection';
import { PanelistConnectionSteps } from '../PanelistConnectionSteps';

type Props = {
  pharmacyPanelist: PharmacyPanelist;
};

export const ConnectionEstablishingBanner = ({ pharmacyPanelist }: Props) => (
  <Banner
    icon={<ClockFilledIcon fontSize="medium" sx={{ marginRight: 1 }} />}
    title={
      <Stack gap={2}>
        <Trans>
          Votre connexion extracteur est <strong>en cours de mise en place</strong>. Cela peut
          prendre quelques jours.
        </Trans>
        {pharmacyPanelist.panelist && (
          <PanelistConnectionSteps
            panelist={pharmacyPanelist.panelist}
            onboardingUrl={pharmacyPanelist.onboarding_url}
          />
        )}
      </Stack>
    }
    color="warning"
    sx={{ mt: 2 }}
    textProps={{ variant: 'body1' }}
  />
);
